export default "__VITE_ASSET__JZt_R9u$__"